<button
  #trigger
  type="button"
  class="docs-btn"
  [class.is-open]="open()"
  (click)="openDocs()"
  aria-haspopup="dialog"
  [attr.aria-expanded]="open()"
  aria-label="Documentation"
  pTooltip="Documentation"
  tooltipPosition="bottom"
  [appendTo]="'body'"
  data-testid="customer-docs-button"
>
  <i class="pi pi-book" aria-hidden="true"></i>
</button>

<p-drawer
  [visible]="open()"
  (visibleChange)="onVisibleChange($event)"
  (onShow)="onDrawerShow()"
  appendTo="body"
  position="right"
  [modal]="true"
  [blockScroll]="true"
  [closeOnEscape]="true"
  styleClass="slm-docs-drawer"
  ariaCloseLabel="Close documentation"
>
  <ng-template #header>
    <div class="docs-head">
      <span class="docs-head__title">Documentation</span>
      @if (status() === 'ready') {
      <button
        type="button"
        class="docs-head__new-tab"
        (click)="openInNewTab()"
        aria-label="Open in new tab"
        data-testid="customer-docs-open-new-tab"
      >
        <i class="pi pi-external-link" aria-hidden="true"></i>
        <span class="docs-head__new-tab-label">Open in new tab</span>
      </button>
      }
    </div>
  </ng-template>

  <div class="docs-body" data-testid="customer-docs-drawer">
    @switch (status()) { @case ('unavailable') {
    <output class="docs-state" data-testid="customer-docs-unavailable">
      <i class="pi pi-info-circle docs-state__icon" aria-hidden="true"></i>
      <span class="docs-state__title">The documentation isn't available yet.</span>
      <span class="docs-state__text">Please check back later.</span>
    </output>
    } @case ('error') {
    <div class="docs-state" role="alert" data-testid="customer-docs-error">
      <i class="pi pi-exclamation-circle docs-state__icon docs-state__icon--error" aria-hidden="true"></i>
      <span class="docs-state__title">We couldn't open the documentation.</span>
      <span class="docs-state__text">Please try again in a moment.</span>
      <button type="button" class="docs-state__retry" (click)="retry()" data-testid="customer-docs-retry">
        Try again
      </button>
    </div>
    } @case ('ready') { @if (!frameSettled()) {
    <div class="docs-state docs-state--overlay" aria-live="polite" data-testid="customer-docs-loading">
      <i class="pi pi-spin pi-spinner docs-state__icon" aria-hidden="true"></i>
      <span class="docs-state__text">Loading documentation…</span>
    </div>
    }
    <iframe
      #frame
      class="docs-frame"
      title="SLM documentation"
      referrerpolicy="no-referrer"
      sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-forms allow-downloads"
      (load)="onFrameLoad($event)"
      data-testid="customer-docs-frame"
    ></iframe>
    } @default {
    <div class="docs-state" aria-live="polite" data-testid="customer-docs-loading">
      <i class="pi pi-spin pi-spinner docs-state__icon" aria-hidden="true"></i>
      <span class="docs-state__text">Loading documentation…</span>
    </div>
    } }
  </div>

  <ng-template #footer>
    @if (status() === 'ready') {
    <p class="docs-hint" data-testid="customer-docs-hint">
      Not showing?
      <button type="button" class="docs-hint__link" (click)="openInNewTab()">Open the documentation in a new tab</button
      >.
    </p>
    } @if (newTabFailed()) {
    <p class="docs-hint docs-hint--error" role="alert" data-testid="customer-docs-new-tab-error">
      We couldn't open a new tab. Check that pop-ups are allowed, then try again.
    </p>
    }
  </ng-template>
</p-drawer>
